import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { useQuery } from "react-query";

interface ParamsProps {
    pnu: string;
}

const fetchData = async ({ pnu }: ParamsProps) => {
    const { data } = await axiosInstance.get(`${axiosPath.mapFieldDetail}/${pnu}`);
    return data;
};

const useGetFieldTableContents = ({ pnu }: ParamsProps) => {
    return useQuery(["fieldTableContents", pnu], () => fetchData({ pnu }), {
        enabled: !!pnu,
    });
};

export default useGetFieldTableContents;
